import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WarningBoldIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.984 19.9999C13.424 19.9999 14.768 19.6319 16.016 18.8959C17.215 18.209 18.2091 17.2148 18.896 16.0159C19.6239 14.7973 20.0056 13.4033 20 11.9839C20 10.5439 19.632 9.1999 18.896 7.9519C18.2091 6.75295 17.215 5.75881 16.016 5.0719C14.7975 4.34398 13.4034 3.96228 11.984 3.9679C10.544 3.9679 9.20002 4.3359 7.95202 5.0719C6.75307 5.75881 5.75893 6.75295 5.07202 7.9519C4.3441 9.17045 3.9624 10.5645 3.96802 11.9839C3.96802 13.4239 4.33602 14.7679 5.07202 16.0159C5.75893 17.2148 6.75307 18.209 7.95202 18.8959C9.17057 19.6238 10.5646 20.0055 11.984 19.9999ZM11.984 1.9999C13.808 1.9999 15.496 2.4559 17.048 3.3679C18.5304 4.21028 19.7576 5.43753 20.6 6.9199C21.5068 8.45261 21.9797 10.2031 21.968 11.9839C21.9797 13.7647 21.5068 15.5152 20.6 17.0479C19.7576 18.5303 18.5304 19.7575 17.048 20.5999C15.5153 21.5067 13.7648 21.9796 11.984 21.9679C10.2032 21.9796 8.45273 21.5067 6.92002 20.5999C5.4399 19.7439 4.21401 18.5098 3.36802 17.0239C2.46338 15.4991 1.9905 13.7569 2.00002 11.9839C2.00002 10.1759 2.45602 8.4959 3.36802 6.9439C4.2276 5.46031 5.46043 4.22748 6.94402 3.3679C8.46886 2.46325 10.211 1.99038 11.984 1.9999ZM11 6.9679H12.968V12.9679H11V6.9679ZM11 14.9839H12.968V16.9999H11V14.9839Z'
                fill='currentColor'
            />
        </>
    ),
})

WarningBoldIcon.displayName = 'WarningBoldIcon'
